import React, { FC } from 'react'

const PlusIcon: FC = () => (
  <svg width="21" height="22" viewBox="0 0 21 22" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5013 20.3334V11M10.5013 11V1.66669M10.5013 11L1.16797 11M10.5013 11L19.8346 11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default PlusIcon
